<script>

  /*
  |--------------------------------------------------------------------------
  | Dependency Definitions
  |--------------------------------------------------------------------------
  */

  import Vue from 'vue';
  import vueDebounce from 'vue-debounce';

  import axios from 'axios';
  import Swal from 'sweetalert2';

  Vue.use(vueDebounce);



  /*
  |--------------------------------------------------------------------------
  | Component Implementation
  |--------------------------------------------------------------------------
  */

  export default {
    name: 'add-product',

    props: [
      'productID',
      'language'
    ],

    created() {
      if (localStorage.product_requests == null) {
        this.currentItems = [];
      } else {
        this.currentItems = JSON.parse(localStorage.product_requests);

        if (!Array.isArray(this.currentItems)) {
          this.currentItems = [this.currentItems];
        }
      }
    },

    data() {
      return {
        currentItems: []
      }
    },

    computed: {
      productAdded() {
        return (this.currentItems.includes(this.productID));
      },

      addLabel() {
        if (this.language == 'sv') {
          return 'Lägg till förfrågan';
        }

        return 'Add to quote';
      },

      addedLabel() {
        if (this.language == 'sv') {
          return 'Visa produktlistan';
        }

        return 'Browse the list';
      },

      addedMessage() {
        if (this.language == 'sv') {
          return 'Produkten lagd i Mina Förfrågningar!';
        }

        return 'Product added';
      },

      listLink() {
        if (this.language == 'sv') {
          return '/mina-forfragningar';
        }

        return '/en/request-quote';
      }
    },

    methods: {
      addProduct() {
        if (!this.productAdded) {
          this.currentItems.push(this.productID);

          localStorage.product_requests = JSON.stringify(this.currentItems);

          Swal.fire({
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
            title: this.addedMessage
          });
        }
      }
    }
  };
</script>

<template>
  <div>
    <p v-if="!productAdded" @click="addProduct">{{ addLabel }}</p>
    <a v-if="productAdded" :href="listLink">{{ addedLabel }}</a>
  </div>
</template>

<style lang="scss" scoped>

  /*
  |--------------------------------------------------------------------------
  | Add Product
  |--------------------------------------------------------------------------
  */

  .search {
    position: relative;
  }

  .search-no-result-box {
    position: absolute;
    top: 40px;
    left: 0px;
    right: 0px;

    padding: 5px;

    background-color: #fff;
    border: 1px solid #ccc;

    z-index: 10000;
  }

  .search-result-box {
    position: absolute;
    top: 40px;
    left: 0px;
    right: 0px;

    padding: 5px;

    background-color: #fff;
    border: 1px solid #ccc;

    z-index: 10000;
  }

  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;

    color: #000;

    cursor: pointer;
  }
</style>
